// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__3wSN-","navItem":"Navigation_navItem__2LD9p","active":"Navigation_active__2sx7R","fadeIn":"Navigation_fadeIn__3m6vx"};